// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Angel-dew.jpg";
import thumb1 from "../assets/images/All-Products/AngelDew.png";
import thumb2 from "../assets/images/New-Products/Angel-dew.jpg";
import thumb3 from "../assets/images/New-Products/extra/Angel-dew.jpg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Angel Dew</h2>
              <p className="sub-heading text-muted">DELICATE SKIN DEFENSE</p>
              <h5>Product Overview</h5>
              <p>
                Infant’s skin has faster rate of trans-epidermal water loss due to thinner stratum corneum and epidermis.
                They also have lower levels of Natural Moisturizing Factors.
                Conventional emollients may increase the risk of infection in preterm newborns and might induce toxic systemic effects,
                hence we have come up with a formulation which is recommended to soothe baby’s delicate skin and it is also safe to be used by pregnant mothers.
                It gets absorbed easily into the skin, lending it a smooth finish. Angel Dew is a non-greasy and fast absorbing body lotion. It is PEG free and contains all natural ingredients.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Angel Dew?</span>
                </h3>
                <p>
                  Apply it on the face, and body, and rub it gently in a circular motion.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "precautions", "recommended"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "recommended"
                          ? "RECOMMENDED FOR"
                          : tab === "precautions"
                            ? "PRECAUTIONS"
                            : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Paraben, Silicon, and PEG free.</li>
                    <li>Eco-certified ingredients.</li>
                    <li>Preservative free.</li>
                    <li>Vegan and Natural.</li>
                    <li>Hydrating and Nourishing.</li>
                    <li>Preserves the skin’s natural barrier.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Pour Angel Dew Lotion on your hands.</li>
                      <li>Apply it on the face, body, and rub it gently in circular motion.</li>
                      <li>For best results, apply immediately after bath.</li>
                    </ul>



                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>5% Squalane:</strong> Squalene comprises about 9% of human vernix. It is an emollient that is safe for sensitivity-prone skin.</li>
                      <li><strong>Olivatis®-18:</strong> Ultra-mild liquid crystal, a superior O/W emulsifier with skin-moisturizing and protecting properties.</li>
                      <li><strong>Shea butter:</strong> Contains fatty acids and Vitamins A & E, providing superior moisturizing effects. Keeps skin smooth and supple.</li>
                      <li><strong>Coconut oil:</strong> Helps lock in moisture due to its high lauric acid content. Beneficial for skin conditions like eczema, dermatitis, and xerosis.</li>
                      <li><strong>Plant Vitamin E:</strong> Helps prevent sensations of itching and rashes.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "recommended" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Infants, toddlers, preschool, and school-age children.</li>
                      <li>Pregnant mothers.</li>
                      <li>Soothing the delicate skin.</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Avoid contact with eyes.</li>
                      <li>If the lotion gets into the eyes, rinse thoroughly with cold water.</li>
                    </ul>


                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
